define('views/modules/calendar/nutrition/food/suggestion/food-suggestion-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/nutrition/entry-tag',
    // Views
    'views/modules/calendar/nutrition/food/food-content',
    'views/modules/calendar/nutrition/food/list/food-list',
    'views/modules/calendar/nutrition/food/suggestion/list/food-suggestion-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    EntryTagService,
    // Views
    VFoodContent,
    VFoodList,
    VFoodSuggestionItem
) {

    var VFoodSuggestionContent = VFoodContent.extend({
        initialize: function(options) {
            this.collection = EntryTagService.collection;
        },

        _initList: function() {
            return new VFoodList({
                collection: this.collection,
                item: VFoodSuggestionItem,
                async: false
            });
        },

        fetch: function() {
            EntryTagService.fetch();
        },
    });

    return VFoodSuggestionContent;
});

